type Props = {
  key?: string;
  children?: React.ReactNode;
  // All other props
  [x: string]: any;
};

const TableRow = ({ children, ...rest }: Props) => {
  return (
    <tr className="dark:hover:bg-primary-900 h-9" {...rest}>
      {children}
    </tr>
  );
};

export default TableRow;
